import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useState, useRef } from 'react';
import { Button, Form, Row, Col, Alert } from 'react-bootstrap'; // Removido Modal
import { Link, useNavigate } from 'react-router-dom';
import { Originador } from '../../../shared/model/originador';
import { MatrizDTO } from '../../../shared/dto/matrizDTO';
import Spinner from '../../../shared/spinner';
import { ButtonAlterar, ButtonAtivar, ButtonInativar } from '../../../shared/buttons';
import OriginadorService from '../../../services/originadorService';
import MatrizService from '../../../services/matrizService';
import ImportacaoService from '../../../services/importacaoService';
import ConfirmModal from '../../../shared/customAlertConfirm';
import { useVerificaPermissao } from '../../../shared/useVerificaPermissao';
import { faFilter, faRefresh, faFileImport, faDownload, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ResponsivePagination from 'react-responsive-pagination';
import { useSlug } from '../../hooks/UseSlug';
import { ProtectedAction, ProtectedActionInterno } from '../../../AccessControl';

function OriginadorComponent() {
  useVerificaPermissao();
  const navigate = useNavigate();
  const slug = useSlug(); // 2. Obtenção do Slug


  // Services
  const originadorService = new OriginadorService();
  const matrizService = new MatrizService();
  const importacaoService = new ImportacaoService();

  // States Principais
  const [loading, setLoading] = useState(true);
  const [originador, setOriginador] = useState<Originador[]>([]);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [currentAction, setCurrentAction] = useState<{ id: any; ativo: boolean } | null>(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [razaoSocialFiltro, setRazaoSocialFiltro] = useState('');

  // Controle de Painéis (Filtros e Importação)
  const [filtrosOpen, setFiltrosOpen] = useState(false);
  const [importacaoOpen, setImportacaoOpen] = useState(false);

  const [matrizFiltro, setMatrizFiltro] = useState<string>('');
  const [codigoFiltro, setCodigoFiltro] = useState('');
  const [nomeFiltro, setNomeFiltro] = useState('');
  const [siglaFiltro, setSiglaFiltro] = useState('');
  const [cidadeFiltro, setCidadeFiltro] = useState('');
  const [statusFiltro, setStatusFiltro] = useState('');
  const [matrizes, setMatrizes] = useState<MatrizDTO[]>([]);

  // States de Importação
  const [fileToUpload, setFileToUpload] = useState<File | null>(null);
  const [importLoading, setImportLoading] = useState(false);
  const [importMessage, setImportMessage] = useState<{ type: 'success' | 'danger', text: string } | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const pageSize = 10;

  // --- Funções de Toggle dos Painéis ---
  const toggleFiltros = () => {
    setFiltrosOpen(!filtrosOpen);
    setImportacaoOpen(false); // Fecha importação se abrir filtros
  };

  const toggleImportacao = () => {
    setImportacaoOpen(!importacaoOpen);
    setFiltrosOpen(false); // Fecha filtros se abrir importação
    setImportMessage(null); // Limpa mensagens anteriores
  };

  // --- Funções de Listagem ---
  const listarOriginador = async (page = 1) => {
    try {
      setLoading(true);
      const filtrosData: any = {};
      if (matrizFiltro) filtrosData.matriz = matrizFiltro;
      if (codigoFiltro) filtrosData.codigo = codigoFiltro;
      if (nomeFiltro) filtrosData.nome = nomeFiltro;
      if (razaoSocialFiltro) filtrosData.razaoSocial = razaoSocialFiltro;
      if (cidadeFiltro) filtrosData.cidade = cidadeFiltro;
      if (statusFiltro !== '') filtrosData.ativo = statusFiltro;

      const response = await originadorService.listarOriginador(page - 1, pageSize, filtrosData);
      const data = response.data;

      setOriginador(data.content || []);
      setTotalPages(data.totalPages || 1);
      setCurrentPage(page);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // --- Funções Auxiliares de UI ---
  const ColorDisplay = ({ color }: { color?: string }) => {
    if (!color) return <span>-</span>;
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span style={{
          height: '20px',
          width: '20px',
          backgroundColor: color,
          borderRadius: '50%',
          display: 'inline-block',
          marginRight: '8px',
          border: '1px solid #ccc'
        }}></span>
        {color.toUpperCase()}
      </div>
    );
  };

  const handlePageChange = (page: number) => {
    listarOriginador(page);
  };

  const ativarInativarOriginador = (id: any, ativo: boolean) => {
    setCurrentAction({ id, ativo });
    setConfirmOpen(true);
  };

  const handleConfirm = async () => {
    if (currentAction) {
      const { id } = currentAction;
      try {
        await originadorService.ativarInativarOriginador(id);
        listarOriginador(currentPage);
      } catch (err) {
        console.error(err);
      } finally {
        setConfirmOpen(false);
        setCurrentAction(null);
      }
    }
  };

  // --- LÓGICA DE IMPORTAÇÃO ---

  const handleDownloadModelo = async () => {
    try {
      const response = await importacaoService.baixarModelo('ORIGINADOR');

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'modelo_importacao_originador.xlsx');
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    } catch (error) {
      console.error("Erro ao baixar modelo", error);
      setImportMessage({ type: 'danger', text: 'Erro ao baixar o modelo.' });
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setImportMessage(null);
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const extension = file.name.split('.').pop()?.toLowerCase();

      if (extension !== 'xlsx' && extension !== 'csv') {
        setImportMessage({ type: 'danger', text: 'Formato inválido. Apenas .xlsx e .csv são permitidos.' });
        setFileToUpload(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }
      setFileToUpload(file);
    }
  };

  const handleImportar = async () => {
    if (!fileToUpload) {
      setImportMessage({ type: 'danger', text: 'Selecione um arquivo para importar.' });
      return;
    }

    try {
      setImportLoading(true);
      await importacaoService.importar('ORIGINADOR', fileToUpload);

      setImportMessage({ type: 'success', text: 'Importação realizada com sucesso!' });
      setFileToUpload(null);
      if (fileInputRef.current) fileInputRef.current.value = "";

      // Recarrega a lista após importar
      listarOriginador(1);

      // Fecha o painel após sucesso (opcional, igual ao modal)
      setTimeout(() => {
        setImportacaoOpen(false);
        setImportMessage(null);
      }, 3000);

    } catch (error: any) {
      console.error("Erro na importação", error);
      const msg = error.response?.data || 'Erro ao processar importação.';
      setImportMessage({ type: 'danger', text: msg });
    } finally {
      setImportLoading(false);
    }
  };

  // --- Effects ---
  useEffect(() => {
    listarOriginador(1);
    const carregarMatrizes = async () => {
      try {
        const response = await matrizService.listarTodasMatrizesAtivas();
        setMatrizes(response.data || []);
      } catch (error) {
        console.error("Erro ao carregar matrizes:", error);
      }
    };
    carregarMatrizes();
  }, []);

  return (
    <>
      <div className="position-relative m-md-3">
        <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h5>Origens &gt; {Originador.DESCRITIVO_GERAL}</h5>
          <div style={{ display: 'flex', gap: '10px' }}>
            {/* Botão de Filtros */}
            <Button id="App-button-cor-principal-escura" onClick={toggleFiltros} active={filtrosOpen}>
              <FontAwesomeIcon icon={faFilter} style={{ marginRight: '10px' }} />
              Filtros
            </Button>

            {/* --- BOTÃO: IMPORTAR (Toggle) --- */}
            <ProtectedActionInterno>
              <Button variant="outline-primary" onClick={toggleImportacao} active={importacaoOpen}>
                <FontAwesomeIcon icon={faFileImport} style={{ marginRight: '10px' }} />
                Importar
              </Button>
            </ProtectedActionInterno>

            {/* Botão Novo */}
            <Button
              onClick={() => navigate(`${slug ? `/${slug}` : ''}/origens-originador/inclusao`, { state: { id: null } })}
              id="App-button-cor-principal-escura"
            >
              + Nova {Originador.DESCRITIVO_GERAL}
            </Button>
          </div>
        </div>

        {/* --- ÁREA DE IMPORTAÇÃO (EXPANSÍVEL) --- */}
        {importacaoOpen && (
          <div className="card card-body mb-4" style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6' }}>
            <h6 className="card-title mb-3">
              <FontAwesomeIcon icon={faFileImport} className="me-2" />
              Importação em Lote
            </h6>
            <Row className="align-items-end g-3">
              <Col md={3}>
                <Form.Label>Passo 1: Modelo</Form.Label>
                <Button variant="outline-secondary" className="w-100" onClick={handleDownloadModelo}>
                  <FontAwesomeIcon icon={faDownload} className="me-2" />
                  Baixar Modelo
                </Button>
              </Col>

              <Col md={5}>
                <Form.Group controlId="formFile">
                  <Form.Label>Passo 2: Selecione o Arquivo (.xlsx)</Form.Label>
                  <Form.Control
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    accept=".xlsx, .csv"
                  />
                </Form.Group>
              </Col>

              <Col md={4} className="d-flex gap-2">
                <Button
                  id="App-button-cor-principal-escura"
                  className="flex-grow-1"
                  onClick={handleImportar}
                  disabled={!fileToUpload || importLoading}
                >
                  {importLoading ? <Spinner loading={true} /> : 'Confirmar Importação'}
                </Button>
                <Button variant="secondary" onClick={() => {
                  setImportacaoOpen(false);
                  setImportMessage(null);
                  setFileToUpload(null);
                }}>
                  <FontAwesomeIcon icon={faTimes} />
                </Button>
              </Col>
            </Row>

            {importMessage && (
              <Alert variant={importMessage.type} className="mt-3 mb-0">
                {importMessage.text}
              </Alert>
            )}
          </div>
        )}

        {/* --- ÁREA DE FILTROS (EXISTENTE) --- */}
        {filtrosOpen && (
          <>
            <Row className="mb-4" style={{ marginTop: '15px' }}>
              <Form.Group as={Col} md='3' controlId="formSelectMatriz">
                <Form.Label>Matriz</Form.Label>
                <Form.Select value={matrizFiltro} onChange={(e) => setMatrizFiltro(e.target.value)}>
                  <option value="">Selecione</option>
                  {matrizes.map((matriz) => (
                    <option key={matriz.id} value={String(matriz.id)}>
                      {matriz.id} - {matriz.nome}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group as={Col} md='2' controlId="formCodigoFiltro">
                <Form.Label>Código</Form.Label>
                <input type="text" className="form-control" value={codigoFiltro} onChange={(e) => setCodigoFiltro(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md='4' controlId="formSiglaFiltro">
                <Form.Label>Sigla</Form.Label>
                <input type="text" className="form-control" value={siglaFiltro} onChange={(e) => setSiglaFiltro(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md='4' controlId="formNomeFiltro">
                <Form.Label>Nome</Form.Label>
                <input type="text" className="form-control" value={nomeFiltro} onChange={(e) => setNomeFiltro(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md='4' controlId="formRazaoSocialFiltro">
                <Form.Label>Razão Social</Form.Label>
                <input type="text" className="form-control" value={razaoSocialFiltro} onChange={(e) => setRazaoSocialFiltro(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md='3' controlId="formCidadeFiltro">
                <Form.Label>Cidade</Form.Label>
                <input type="text" className="form-control" value={cidadeFiltro} onChange={(e) => setCidadeFiltro(e.target.value)} />
              </Form.Group>
              <Form.Group as={Col} md='3' controlId="formStatusFiltro">
                <Form.Label>Status</Form.Label>
                <Form.Select value={statusFiltro} onChange={(e) => setStatusFiltro(e.target.value)}>
                  <option value="">Todos</option>
                  <option value="true">Ativos</option>
                  <option value="false">Inativos</option>
                </Form.Select>
              </Form.Group>
            </Row>
            <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <Button id="App-button-cor-principal-escura" onClick={() => listarOriginador(1)}>
                <FontAwesomeIcon icon={faFilter} style={{ marginRight: '5px' }} />
                Aplicar
              </Button>
              <Button variant="secondary" onClick={() => {
                setMatrizFiltro(''); setCodigoFiltro(''); setSiglaFiltro('');
                setNomeFiltro(''); setRazaoSocialFiltro(''); setCidadeFiltro(''); setStatusFiltro('');
                listarOriginador(1);
              }}>
                <FontAwesomeIcon icon={faRefresh} style={{ marginRight: '5px' }} />
                Limpar
              </Button>
            </div>
          </>
        )}

        {/* --- TABELA DE DADOS (EXISTENTE) --- */}
        {loading ? <Spinner loading={loading} /> : (
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th scope="col" id="App-header-table">Código</th>
                  <th scope="col" id="App-header-table">Nome</th>
                  <th scope="col" id="App-header-table">Razão Social</th>
                  <th scope="col" id="App-header-table">Cidade</th>
                  <th scope="col" id="App-header-table">Telefone</th>
                  <th scope="col" id="App-header-table">Email</th>
                  <th scope="col" id="App-header-table">Chave API PH3A</th>
                  <th scope="col" id="App-header-table">Cor Principal</th>
                  <th scope="col" id="App-header-table">Cor Secundária</th>
                  <th scope="col" id="App-header-table">Cor Texto</th>
                  <th scope="col" id="App-header-table">Cor Cabeçalho</th>
                  <th scope="col" id="App-header-table">Cor Tabela</th>
                  <ProtectedAction>
                    <th scope="col" id="App-header-table">Alteração</th>
                    <th scope="col" id="App-header-table">Status</th>
                  </ProtectedAction>

                </tr>
              </thead>
              <tbody>
                {originador.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.nome}</td>
                    <td>{item.razaoSocial}</td>
                    <td>{item.cidade}</td>
                    <td>{item.telefoneComercial}</td>
                    <td>{item.email}</td>
                    <td>{item.apiKey}</td>
                    <td><ColorDisplay color={item.corPrincipal} /></td>
                    <td><ColorDisplay color={item.corSecundaria} /></td>
                    <td><ColorDisplay color={item.corTexto} /></td>
                    <td><ColorDisplay color={item.corCabecalho} /></td>
                    <td><ColorDisplay color={item.corTabela} /></td>
                    <ProtectedAction>
                      <td>
                        <Link to={`${slug ? `/${slug}` : ''}/origens-originador/alteracao`} state={{ id: item.id }}>
                          <ButtonAlterar />
                        </Link>
                      </td>
                      <td>
                        {item.ativo ? (
                          <ButtonInativar onClick={() => ativarInativarOriginador(item.id, item.ativo)} />
                        ) : (
                          <ButtonAtivar onClick={() => ativarInativarOriginador(item.id, item.ativo)} />
                        )}
                      </td>
                    </ProtectedAction>
                  </tr>
                ))}
              </tbody>
            </table>

            <ResponsivePagination
              current={currentPage}
              total={totalPages}
              onPageChange={handlePageChange}
            />

            {confirmOpen && (<ConfirmModal message={currentAction?.ativo ? 'Tem certeza que deseja inativar este item?' : 'Tem certeza que deseja ativar este item?'} onConfirm={handleConfirm} onCancel={() => { setConfirmOpen(false); setCurrentAction(null) }} />)}
          </div>
        )}
      </div>
    </>
  );
}

export default OriginadorComponent;